import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@mantine/core';

import { HeadquarterContext } from 'context/HeadquarterContext';

import { useTranslation } from 'i18n';

import { CUBOH_INTEGRATIONS_PATH, LOCATION_PATH } from 'constants/path';

import HalftonePOSIntegrations from 'assets/images/halftone-posintegrations.png';
import { CTACard } from 'components/CTACard';

const NS = 'manageMenus';

export const RedirectPOSIntegrations: FunctionComponent = () => {
  const { t } = useTranslation(NS);
  const { location } = useContext(HeadquarterContext);
  const navigate = useNavigate();
  const integrationsUrl = `${LOCATION_PATH}/${location.id}${CUBOH_INTEGRATIONS_PATH}`;

  const ctaButton = (
    <Button onClick={() => void navigate(integrationsUrl)}>
      {t('RedirectPOSIntegrations.cta')}
    </Button>
  );

  return (
    <CTACard
      image={HalftonePOSIntegrations}
      text={t('RedirectPOSIntegrations.message')}
      button={ctaButton}
    />
  );
};
